'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var range = _underscore2['default'].range;
var defaults = _underscore2['default'].defaults;

var numeral = require('numeral');

var formatMoney = function formatMoney(money) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var cfg = defaults(options, { precision: 2, symbol: true });

  var decimals = range(cfg.precision).map(function (d) {
    return '0';
  }).join('');
  var symbol = cfg.symbol ? '$' : '';

  if (decimals) {
    return numeral(money).format(symbol + '0,0.' + decimals);
  } else {
    return numeral(money).format(symbol + '0,0');
  }
};

exports['default'] = formatMoney;
module.exports = exports['default'];